import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, filter, throwError } from 'rxjs';
import { handleError } from '../utils/erro-handler';
import { getApiUrl, getLanguages } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminService {


  readonly BASE_URL = getApiUrl()
  readonly USER_URL = "users"
  readonly SLIDER_URL = "sliders"
  readonly VISION_URL = "visions"
  readonly ARTICLE_URL = "articles"
  readonly PROJECT_URL = "projects"
  readonly BOOK_URL = "books"
  readonly BLOG_URL = "blogs"
  readonly EVENT_URL = "events"
  readonly ABOUT_URL = "abouts"
  readonly MULTIMEDIA_URL = "multimedias"
  readonly NEWS_PAPER_URL = "news-papers"
  readonly MENUSCRIPT_URL = "menuscripts"
  readonly BIOGRAPHY_URL = "biographies"
  readonly DONOR_URL = "donors"
  
  readonly ITEM_PERPAGE = 10
  constructor(private http: HttpClient) { }

  getWebsiteLanguages() {
    let languages = [
      { "id": getLanguages().EN_US, "value": "English" },
      { "id": getLanguages().FA_IR, "value": "فارسی" }
    ]
    return languages
  }

  getRecordList(url, filter) {
    return this.http.get(`${this.BASE_URL}/${url}/list-all/`, {params:filter})
      .pipe(
        catchError(handleError)
      );
  }

  createRecord(url, data) {
    return this.http.post(`${this.BASE_URL}/${url}/`, data).pipe(
      catchError(handleError)
    );
  }

  getRecordById(url, id) {
    return this.http.get(`${this.BASE_URL}/${url}/${id}`)
  }
  
  updateRecord(url, data, id) {
    return this.http.put(`${this.BASE_URL}/${url}/${id}`, data).pipe(
      catchError(handleError)
    );
  }

  deleteRecordById(url, id) {
    return this.http.delete(`${this.BASE_URL}/${url}/${id}`)
      .pipe(
      catchError(handleError)
    )
  }

  uploadImage(image, url) {
    return this.http.post(`${this.BASE_URL}/${url}/upload-image/`, image)
      .pipe(
      catchError(handleError)
    )
  }

  uploadPdf(pdf, url) {
    return this.http.post(`${this.BASE_URL}/${url}/upload-pdf/`, pdf)
      .pipe(
      catchError(handleError)
    )
  }

  addImage(image, id, url) {
    return this.http.post(`${this.BASE_URL}/${url}/upload-image/${id}`, image)
      .pipe(
      catchError(handleError)
    )
  }

  deleteImage(id, url) {
    return this.http.delete(`${this.BASE_URL}/${url}/delete-image/${id}`)
      .pipe(
      catchError(handleError)
    )
  }
  getVisionType() {
    return this.http.get(`${this.BASE_URL}/visions/vision-type/list/`)
      .pipe(
      catchError(handleError)
    )
  }

  getArticleType() {
    return this.http.get(`${this.BASE_URL}/articles/article-type/list/`)
    .pipe(
    catchError(handleError)
  )
  }

  getProjectCategory() {
    return this.http.get(`${this.BASE_URL}/projects/project-category/list/`)
    .pipe(
    catchError(handleError)
  )
  }

  getBookCategory() {
    return this.http.get(`${this.BASE_URL}/books/book-category/list/`)
    .pipe(
    catchError(handleError)
  )
  }
}
